<div class="section-gap" *ngIf="imagePosition != 'image-as-background'">
  <div class="container">
    <div class="blog-alternate mb-5">
      <div class="row flex-lg-row flex-column">
        <div class="col-12 col-lg-auto" *ngIf="imagePosition=='left'" [ngStyle]="{'max-width': displayWidth < 992 ? '100%' : '50%'}">
          <div class="overlay-wrap" [ngStyle]="{'max-width': imageWidth, 'max-height': imageHeight }">
            <kla-image-object [imageHeight]="imageHeight" [imageWidth]="imageWidth" [imageClass]="'img-fluid w-100 border-rad shadow-md image'" [imageObject]="imageObject"></kla-image-object>
          </div>
        </div>

        <div [class]="imagePosition=='full-width' ? 'col-12': 'col-lg-6 col-12'">
          <app-badges [badges]="config.badges"></app-badges>
          <div>
            <div class="d-flex align-items-center">
              <h3 [id]="config.header | stripSpecialChars">{{config.header}}</h3>
              <kla-social-media-buttons class="mb-2" [linkFragment]="config.header"></kla-social-media-buttons>
            </div>
            <app-dynamic-content
              [contentId]="'indicator-basic-desc'"
              [htmlContent]="config.description">
            </app-dynamic-content>
          </div>
        </div>
        <div class="col-12 col-lg-6 image-right" *ngIf="imagePosition=='right'" [ngStyle]="{'max-width': displayWidth < 992 ? '100%' : '50%'}">
          <div class="overlay-wrap" [ngStyle]="{'max-width': imageWidth, 'max-height': imageHeight }">
            <kla-image-object [imageHeight]="imageHeight" [imageWidth]="imageWidth" [imageClass]="'img-fluid w-100 border-rad shadow-md image'" [imageObject]="imageObject"></kla-image-object>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="imagePosition=='full-width'">
        <div class="col-12 d-flex justify-content-center">
          <kla-image-object [ngClass]="imageWidth=='100%' ? 'w-100' : ''" [imageHeight]="imageHeight" [imageWidth]="imageWidth" [imageClass]="'img-fluid w-100 border-rad image'" [imageObject]="imageObject"></kla-image-object>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="card text-white text-center border-0" *ngIf="imagePosition == 'image-as-background'">
  <div class="blog-detail-thumb" [ngStyle]="{'background-image': 'url(' + imagePath + ')'}">
    <div *ngIf="config.header || config.description"
         class="black-tp-layer pos-center py-6 d-lg-flex align-items-lg-center justify-content-lg-center">
      <div class="center-holder">
        <div class="container">
          <div class="row">
            <div class="col-sm-12 col-md-8 mx-auto">
              <h2 class="mb-4 text-white">{{config.header}}</h2>
              <div class="card-text">
                <app-dynamic-content
                  [contentId]="'indicator-basic-desc'"
                  [htmlContent]="config.description">
                </app-dynamic-content>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
